<template>
    <div class="roothome">

        <div class="wrapper">
            <div>
                <!-- ################    Top Menu Bar    ################# -->
                <div align="center" class="head0">
                    <div align="center" class="head0_2" style="background: var(--bg-header-color);">
                        <div class="head1">
                            <img src="/static/imgs/ic_back_b.png" alt="menu" class="im_menu2" @click="goToBack()" onMouseOver="this.style.cursor='pointer'">
                        </div><div class="head2">
                            <router-link v-if="estabs_full.length == 1" :to="{ name: 'mHome'}" style="display: flex; width: 100%; height: 100%;object-fit: contain; justify-content: flex-start; align-items: center;">
                                <!--<img src="/static/imgs/advicep_horizontal_small.png" alt="Logo Advice" class="im_logol">-->
                                <span class="tx_title_guia">{{getInterText(inter_ind.seu_guia_turistico)}}</span>
                            </router-link>
                            <router-link v-else :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: cat.id}, name: 'mHome'}" style="display: flex; width: 100%; height: 100%;object-fit: contain; justify-content: flex-start; align-items: center;">
                                <!--<img src="/static/imgs/advicep_horizontal_small.png" alt="Logo Advice" class="im_logol">-->
                                <span class="tx_title_guia">{{getInterText(inter_ind.seu_guia_turistico)}}</span>
                            </router-link>
                        </div><div  class="head3">
                            <div class="di_profile_m3" @click="showSearch()">
                                <img v-if="showingSearch" src="/static/imgs/ic_lupa_clicked.png" alt="lupa" class="im_profile_m2_square">
                                <img v-else               src="/static/imgs/ic_lupa_.png" alt="lupa" class="im_profile_m2_square" >
                            </div>
                            <div v-if="!user.sucess" class="di_profile_m2" @click="setShowLogin(true)">
                                <img src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile_m2">
                            </div>
                            <div v-if="user.sucess" id="botao_profile1" class="di_profile_m2" @click="showPopEscritorio()">
                                <div v-if='user.foto === ""' class="im_profile_m2" style="justify-content: center; align-items: center; background-color: var(--bg-blue)">
                                    <span class="tx_initials" >{{ getInitials(user) }}</span>
                                </div>
                                <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile_m2">
                                <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile_m2">
                            </div>
                            <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                                <div class="arrow_top2" style="margin-right: 6vh;"></div>
                                <span class="tx_login_b" >{{ getFirstAndLastWords(user.nome) }}</span>
                                <div class="tx_login" @click.prevent.stop="goToMinhaPagina()">
                                <!--<router-link class="tx_login" to="mMinhaPagina">-->
                                <!--<router-link :to="{ query: { id: item.id }, params: { stabs: estabs_full, categs: cats_full}, name: 'mEstabelecimento'}">-->
                                    <span class="tx_login" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.minha_conta) }}</span>
                                <!--</router-link>-->
                                </div>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('mEditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- ################    Busca    ################# -->
                    <div id="search_s_id" class="search0" v-if="showingSearch">
                        <img src="/static/imgs/ic_back_.png" alt="lupa" class="search_lupa" @click="showSearch()">
                        <input ref="search_i" type="text" v-on:keyup.enter="closeKey()" onsubmit="closeKey()" class="search1"  v-on:keyup="getEstabsSearch()" v-model="search_text" :placeholder="getInterText(inter_ind.pesquisar) + '...'"/>
                    </div>

                </div>


                <!-- ################    Categorias    ################# -->
                <div class="scrollhorizontal">
                    <div v-for="(item, index) in cats_full" class="di_categoria" @click="atualizaEstabs(item.id, true)" v-if="index > 0">
                        <router-link :to="{ query: { idCat: item.id }, params: { stabs: estabs_full, categs: cats_full, idCat: item.id}, name: 'mHome'}">
                            <div style="display: flex; align-items: center; flex-direction: column;">
                                <div class="im_categoria2_d" v-if="item.id != cat.id">
                                    <img onerror="tryReloadImages(this)" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" alt="categorias" class="im_categoria2" style="filter: url(#colorize2);"/>
                                </div>
                                <div class="im_categoria2_d" v-if="item.id == cat.id" style="background-color: var(--bg-blue-circle);">
                                    <img onerror="tryReloadImages(this)" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" alt="categorias" class="im_categoria2" style="margin-top: 7.5px;"/>
                                    <img onerror="tryReloadImages(this)" src="/static/imgs/ic_ball_bright.png" alt="categorias" class="im_categoria2" style="width: 54px; height: 54px; margin-top: -47.5px;"/>
                                </div>
                                <span class="tx_categoria"> {{ getInterCatName(item) }} </span>
                            </div>
                        </router-link>
                    </div>
                </div>

                <!--<div class="notranslate" style="font-weight: bold; background-color: pink; display: flex; flex-direction: column;">-->
                <!--<span @click='changeIdioma(1)'>traduzirEN</span>-->
                <!--<span @click='changeIdioma(2)'>traduzirES</span>-->
                <!--</div>-->

                <!--<div id="trans_area" class="translate_control" style="font-weight: bold; background-color: purple; display: none;">-->
                <!--</div>-->

                <hr style="width: 95%;"/>

                <!-- ################    Title    ################# -->
                <!--<div v-if="cats_full!=null && cats_full.length>0" class="title">-->
                    <!--<img v-if="cat.id>=0" :src="baseUrlImg + 'CATEGORIA/' + cat.imgPath2" alt="categorias" class="im_categoria3" style="filter: url(#colorize2);"/>-->
                    <!--<img v-if="cat.id==-1"  src="/static/imgs/ic_lupa.png" alt="categorias" class="im_categoria3"/>-->
                    <!--<span style="flex-grow: 1; font-size: 2.5vh;" >{{ getInterCatName(cat) }}</span>-->
                    <!--&lt;!&ndash;<img src="/static/imgs/ic_pontos.png" alt="opcoes" class="im_pontos"/>&ndash;&gt;-->
                <!--</div>-->


                <!-- ################    Estabelecimento    ################# -->
                <div class="di_estabelecimento0">

                    <!-- EMPTY STAB -->
                    <div v-if="estab.id == -1" class="di_estabelecimento1">
                        <div style="position: relative; ">
                            <img v-if="estab.tbFotos!=null" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="imgDestaques imgDestaques-empty animated-background"/><br>

                            <div class="div_arrow_l">
                                <img src="/static/imgs/ic_left_2.png" onmouseover="this.src='/static/imgs/ic_left.png';" alt="Foto Anterior" @click.prevent="nextPhoto(-1)" class="im_arrow">
                            </div>
                            <div class="div_arrow_r">
                                <img src="/static/imgs/ic_right_2.png" onmouseover="this.src='/static/imgs/ic_right.png';" alt="Foto Anterior" @click.prevent="nextPhoto(1)" class="im_arrow">
                            </div>
                        </div>
                        <div class="di_im_small">
                            <div class="di_small_p1">
                                <img v-if="estab.tbFotos!=null" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="im_small animated-background"/>
                            </div><div class="di_small_p2">
                            <img v-if="estab.tbFotos!=null" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="Foto Principal" class="im_small animated-background"/><br>
                        </div>
                        </div>
                    </div>

                    <div v-else class="di_estabelecimento1">
                        <div style="position: relative; background-color: var(--empty-color)">
                            <img onerror="tryReloadImages(this)" @click="showGalery(true)" v-if="estab.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + estab.tbFotos[getPhotoIndex(0)].file" alt="Foto Principal" class="imgDestaques"/><br>

                            <div class="div_arrow_l">
                                <img src="/static/imgs/ic_left_2.png" onmouseover="this.src='/static/imgs/ic_left.png';" alt="Foto Anterior" @click.prevent="nextPhoto(-1)" class="im_arrow">
                            </div>
                            <div class="div_arrow_r">
                                <img src="/static/imgs/ic_right_2.png" onmouseover="this.src='/static/imgs/ic_right.png';" alt="Foto Anterior" @click.prevent="nextPhoto(1)" class="im_arrow">
                            </div>

                            <!--<img src="/static/imgs/ic_selo10.png" style="position: absolute; top: 2vh; right: 2vh; object-fit: scale-down; width: 5vh; height: 5vh; "/>-->
                        </div>
                        <div class="di_im_small">
                            <div class="di_small_p1">
                                <img onerror="tryReloadImages(this)" @click="nextPhoto(1)" v-if="estab.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + estab.tbFotos[getPhotoIndex(1)].file" alt="Foto Principal" class="im_small"/>
                            </div><div class="di_small_p2">
                            <img onerror="tryReloadImages(this)" @click="nextPhoto(2)" v-if="estab.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + estab.tbFotos[getPhotoIndex(2)].file" alt="Foto Principal" class="im_small"/><br>
                        </div>
                        </div>
                    </div>
                    <div class="di_estabelecimento2">
                        <div style="display: flex; justify-content: flex-start; align-items: center">
                            <span v-if="estab.id == -1" class="animated-background" style="font-weight: bold; font-size: 2vh; flex-grow: 1; background-color: var(--empty-color);">&nbsp;</span>
                            <span v-else style="font-weight: bold; font-size: 2.5vh; flex-grow: 1;" v-html="decodeChars(estab.nome)">  </span>

                            <img @click="share()" src="/static/imgs/ic_share.png" alt="Share" style="height: 2.3vh; padding-left: 2vh; cursor: pointer;"/>
                        </div>
                        <div class="di_estabelecimento3">
                            <div style="display: flex; align-items: flex-start; width: 50%; flex-direction: column;">
                                <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-bottom: 0.3vh;">
                                    <span style="font-size: 2.8vw; overflow: hidden; white-space:nowrap; text-overflow: ellipsis; width: 45vw;">
                                        {{ getCatsStr(estab) }}
                                    </span>
                                </div>


                                <div class="di_stab_buttons" style="max-height: 4.2vw;">

                                    <!-- ########### AVALIACAO (ESTRELAS) ###########-->
                                    <div style="text-align: left;">
                                        <div class="di_star_wrap_estab" :title="getInterText(inter_ind.avaliacao) + ((estab.avaliacao * 100)/5.0)">
                                            <div alt="estrelas" class="im_star" :style="'width: ' + ((estab.avaliacao * 100)/5.0) + '%;'" align="right"/>
                                        </div>
                                    </div>
                                    <div class="di_star_popup" style="margin-left: 2vw;" v-if="showAvaliacao" id="popup_avaliacao">
                                        <span v-if="estab.avaliacao <= 0" style="font-size: 2.5vh;">Avalie</span>
                                        <span v-else style="font-size: 2.5vh;">{{ getInterText(inter_ind.sua_avaliacao) }}</span>
                                        <div style="display: flex; justify-content: center; margin-top: 1vw; margin-bottom: 2.5vw;">
                                            <div v-for="i in 5" onMouseOver="this.style.cursor='pointer'" @click="changeAvaliacao(i)">
                                                <img v-if="avaliacao < i" class="im_star_single" src="/static/imgs/ic_estrela_empty_single.png"/>
                                                <img v-else class="im_star_single" src="/static/imgs/ic_estrela_filled_single.png" />
                                            </div>
                                        </div>
                                        <img v-if="loading.avaliacao" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up" style="width: 5vw; height: 5vw;">
                                        <div class="button_white_a" style="margin: 0; width: 45%;" onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(estab.id, avaliacao)">
                                            <span style="font-size: 2.1vh;">{{ getInterText(inter_ind.enviar) }}</span>
                                        </div>
                                    </div>
                                    <!--<img src="/static/imgs/ic_back_pink.png" style="display: flex; width: 8%; height: 1.8vh; align-self: stretch; object-fit: contain; margin-left: 2vw;" onMouseOver="this.style.cursor='pointer'" @click="exibeAvaliacao(estab.id)">-->
                                    <div class="button_white_a2" onMouseOver="this.style.cursor='pointer'" @click.prevent.stop="exibeAvaliacao(estab.id)" style="display: flex; margin-left: 0.3vw; margin-top: 0; align-self: stretch; height: 2.2vh; align-items: center;">
                                        <span style="font-size: 1.4vh; padding-left: 1vw; ">{{ getInterText(inter_ind.avalie_nos) }}</span>
                                    </div>
                                </div>
                            </div>


                            <div style="display: flex; justify-content: flex-end; width: 50%;">


                                <!-- ########### SELO 10+ ###########-->
                                <!--<div v-if="estab.is10Mais" style="display: flex; width: 32%; align-items: center; justify-content: flex-start; margin-top: 0vh;">-->
                                    <!--<img src="/static/imgs/ic_selo10.png" style="object-fit: scale-down; width: 4vh; height: 4vh; "/>-->
                                <!--</div>-->


                                <!-- ########### FAVORITOS ###########-->
                                <div style="display: flex; align-items: center; justify-content: center; width: 20%; flex-direction: column;">
                                    <div style="display: flex; justify-content: center;">
                                        <span style="font-size: 2.4vw; width: 16vw; text-align: center;"> {{ getInterText(inter_ind.favoritos) }} </span>
                                    </div>
                                    <div onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(estab.id, -1)">
                                        <img v-if="isFavorite(estab.id)" src="/static/imgs/ic_favoritos.png" alt="favoritos" class="im_fav_m" />
                                        <img v-else src="/static/imgs/ic_favoritos_not.png" alt="favoritos" class="im_fav_m"  />
                                        <img v-if="loading.favorito" src="/static/imgs/loading5.gif" alt="Carregando" class="im_fav_m">
                                    </div>
                                </div>


                                <!-- ########### Ticket Médio (CIFRAO) ###########-->
                                <div v-if="hasSubCatsTicket(estab)" class="di_stab_buttons_m" style="width: 48%;">
                                    <div style="display: flex; justify-content: center;">
                                        <span style="font-size: 2.4vw; text-align: center;">{{ getInterText(inter_ind.ticket_medio) }}</span>
                                    </div>

                                    <div style="display: flex; justify-content: center;">
                                        <div class="di_cifrao_wrap_estab" :title="((getInvestimento(estab) * 100)/5.0)">
                                            <div alt="cifroes" class="im_cifrao" :style="'width: ' + ((getInvestimento(estab) * 100)/5.0) + '%;'" align="right"/>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- AddToAny BEGIN -->
                        <div v-if="showShare" style="text-align: right; margin-top: 1vh">
                            <a :href="getShareLink2(1, estab)" target="_blank"><img src="https://static.addtoany.com/buttons/whatsapp.svg" class="share_types"></a>
                            <a :href="getShareLink2(2, estab)" target="_blank"><img src="https://static.addtoany.com/buttons/facebook.svg" class="share_types"></a>
                            <a :href="getShareLink2(3, estab)" target="_blank"><img src="https://static.addtoany.com/buttons/email.svg" class="share_types"></a>
                            <a :href="getShareLink2(4, estab)" target="_blank"><img src="https://static.addtoany.com/buttons/sms.svg" class="share_types"></a>
                            <a :href="getShareLink2(5, estab)" target="_blank"><img src="https://static.addtoany.com/buttons/twitter.svg" class="share_types"></a>
                            <a :href="getShareLink2(6, estab)" target="_blank"><img src="https://static.addtoany.com/buttons/facebook_messenger.svg" class="share_types"></a>
                        </div>
                        <!-- AddToAny END -->


                        <hr style="width: 85%; border-color: lightgrey; margin-top: 3vh; margin-bottom: 3vh"/>

                        <!--<span v-for="(cat, index) in estab.tbCategoriaEstabelecimentos"> {{ cat.nome }}<span v-if="(index+1)!=estab.tbCategoriaEstabelecimentos.length">, </span> </span><br>-->

                        <div class="translate di_texto">
                            <!--<div id="trans_area" class="translate_control" style="font-weight: bold; background-color: purple; display: none;">-->
                            <!--</div>-->

                            <div v-if="loading.desc" style="display: flex; width: 100%; align-items: center; flex-direction: column;">
                                <img src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">
                            </div>

                            <div v-if="renderDescription" class="txt" v-html="decodeChars(estab.descricao_trans)"></div><br>
                        </div>
                    </div>


                    <div>
                        <iframe v-if="isYouTubeLink(estab.video_link)" width="100%" height="150" :src="'https://www.youtube.com/embed/' + getYoutubeCode(estab.video_link)" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                    </div>

                    <div v-if="estab.site2" style="width: 100%; text-align: right;">
                        <a target="_blank" :href="decodeChars2(estab.site2)">
                            <span class="bt_anun" style="padding-right: 5%; padding-left: 5%; font-size: 2vh"> {{ getInterText(inter_ind.reservar) }} </span>
                        </a>
                    </div>

                    <div style="width: 100%; height: 2vh"/>

                    <!-- ################    Adivce Indica    ################# -->
                    <div v-if=hasAnuncios(estab.id)>
                        <!-- Mais Info - Separator -->
                        <div style="width: 100%; display: flex; flex-direction: row; align-items: center">
                            <img src="/static/imgs/ic_plus.png" style="width: 7%; object-fit: contain;">
                            <div style="background-color: #bdbfc1; width: 100%; height: 1px;"/>
                        </div>

                        <span class="tx_anun_title1">Dica Advice:</span>
                        <div class="div_anun_con" :style="(getAnunciosDecoded(anuncios, estab.id).length === 1) ? 'justify-content: space-evenly;' : ''">
                            <div v-for="(value, index) in getAnunciosDecoded(anuncios, estab.id)" class="div_anun_item" :style="(index < getAnunciosDecoded(anuncios, estab.id).length -1) ? 'margin-right: 5vw;' : 'margin-right: 1vw;'">
                                <img v-if="value.photos !== undefined" onerror="tryReloadImages(this)" class="im_anum" :src="baseUrlImg + '/MARCADOR/' + value.photos[0].file">
                                <div class="dv_anum_t_c">
                                    <span class="tx_anun_title" style="margin-top: 0.5vh; margin-bottom: 0.5vh; text-align: left;" v-html="decodeChars(value.titulo)"></span>
                                    <!--<div style="display: flex; flex-direction: column; align-items: flex-end;">-->
                                        <!--<span class="tx_anun_sub1" style="">A partir de</span>-->
                                        <!--<div style=" display: flex;">-->
                                            <!--<span class="tx_anun_cifrao">R$</span>-->
                                            <!--<span class="tx_anun_title">{{ getCurrency(value.valor) }} </span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                </div>
                                <a v-if="value.tipo == 0" target="_blank" :href="value.link" style="width: 65%; display: flex; justify-content: flex-end; flex-grow: 1; flex-direction: column;">
                                    <span class="bt_anun"> {{ getInterText(inter_ind.comprar) }} </span>
                                </a>
                                <div v-else @click="goToEstabFromAnun(value.link)" style="width: 65%; display: flex; justify-content: flex-end; flex-grow: 1; flex-direction: column;">
                                    <span class="bt_anun"> {{ getInterText(inter_ind.ver) }} </span>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div style="width: 100%; display: flex; flex-direction: row; align-items: center">
                        <img src="/static/imgs/ic_plus.png" style="width: 7%; object-fit: contain;">
                        <div style="background-color: #bdbfc1; width: 100%; height: 1px;"/>
                    </div>

                    <!-- ################    Caixa Mais info.    ################# -->
                    <div class="bodysubp21">
                        <!--<div style="text-align: center; width: 30vw; display: none;">-->
                            <!--<span class="tx_address" v-if="estab.tbTrajeEstabelecimentos!=null && estab.tbTrajeEstabelecimentos.length > 0">{{ getInterText(inter_ind.traje) }}</span>-->
                            <!--<div style="display: flex; flex-direction: row; justify-content: center;">-->
                                <!--<div v-for="item in estab.tbTrajeEstabelecimentos" class="traje" >-->
                                    <!--<span style="font-size: 1.7vh; text-align: center;">{{ getInterTrajeName(item.id) }}</span>-->
                                    <!--<img :src="baseUrlImg + 'TRAJE/' + item.imgPath" alt="traje" class="im_traje">-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->

                        <!--<div style="background-color: white; width: 1px; min-height: 25vmin; margin: 1.5vw;"/>-->

                        <!-- Mais Info - Separator -->

                        <div style="width: 100%;">
                            <div style="display: flex; flex-direction: column; align-items: center;">

                                <!--<span class="tx_address" style="font-family: Humanst521BT" v-if="estab.horario!=null && estab.horario.length>0">{{ getInterText(inter_ind.funcionamento) }}:</span>-->
                                <!--<span class="tx_address" v-if="estab.horario!=null && estab.horario.length>0" style="white-space: pre-line; text-align: center;">{{ estab.horario }}</span>-->

                                <!-- Mais Info - Horario -->
                                <div v-if="estab.horario!=null && estab.horario.length>0" style="width: 100%; display: flex; margin-bottom: 2vh; margin-top: 1vh">
                                    <div style="width: 10%; display: flex; justify-content: flex-start; align-items: center;">
                                        <img class="im_maisinfo" src="/static/imgs/ic_horario.png" alt="local" style="width: 70%; margin-left: -12%;">
                                    </div>
                                    <div style="width: 90%; text-align: left;">
                                        <span class="tx_maisinfo" style="white-space: pre-line; text-align: center; margin-bottom: 1vh">{{ estab.horario }}</span>
                                    </div>
                                </div>

                                <div class="tx_address" v-if="estab.responsavel!=null && estab.responsavel!=undefined && estab.responsavel!='undefined' && estab.responsavel.length>1"><span style="font-family: Humanst521BT">{{ getInterText(inter_ind.responsavel) }}: </span>{{ estab.responsavel }}</div>
                                <!--<div class="tx_address" style="text-align: center; margin-top: 0.5vh;" v-if="estab.site!=null && estab.site!=undefined && estab.site.length > 1"><span style="font-family: Humanst521BT">Site: </span><a style="color: blue" :href="getSiteUrl(estab.site)" target="_blank">{{ estab.site }}</a></div>-->

                                <!-- Mais Info - Site -->
                                <div v-if="estab.site!=null && estab.site!=undefined && estab.site.length > 1" style="width: 100%; display: flex; margin-bottom: 2vh; margin-top: 1vh">
                                    <div style="width: 10%; display: flex; justify-content: flex-start; align-items: center;">
                                        <img class="im_maisinfo" src="/static/imgs/ic_site.png" alt="local" style="width: 70%; margin-left: -12%;">
                                    </div>
                                    <div style="width: 90%; text-align: left;">
                                        <a class="tx_maisinfo" style="color: blue" :href="getSiteUrl(estab.site)" target="_blank">{{ estab.site }}</a>
                                    </div>
                                </div>

                                <!--<div style="background-color: white; height: 1px; min-width: 45vw; margin: 1.5vw;"/>-->

                                <div style="width: 100%; display: flex; margin-top: 0.5vh;">
                                    <div style="width: 10%; display: flex; justify-content: flex-start; align-items: center;">
                                        <img class="im_maisinfo" src="/static/imgs/ic_local_b.png" alt="local" style="width: 50%; margin-left: -5%; ">
                                    </div>
                                    <div style="width: 90%;">
                                        <div style="display: flex; flex-direction: column;">
                                            <div v-if="getAddressRuaNumBairro(estab).length > 39" style="display: flex; flex-direction: column;">
                                                <span class="tx_maisinfo" v-if="getAddressRuaNum(estab).length > 1">{{ getAddressRuaNum(estab) }}</span>
                                                <span class="tx_maisinfo" v-if="getAddressBairroComp(estab).length > 1">{{ getAddressBairroComp(estab) }}</span>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column;">
                                                <span class="tx_maisinfo" v-if="getAddressRuaNumBairro(estab).length > 1">{{ getAddressRuaNumBairro(estab) }}</span>
                                                <span class="tx_maisinfo" v-if="getAddressComp(estab).length > 1">{{ getAddressComp(estab) }}</span>
                                            </div>
                                        </div>
                                        <span class="tx_maisinfo" v-if="(estab.cidade!=null && estab.cidade.length>0) && (estab.cep!=null && estab.cep.length>0)">{{ estab.cidade }} - {{ estab.cep }}</span>
                                        <span class="tx_maisinfo" v-if="(estab.cidade==null || estab.cidade.length==0) && (estab.cep!=null && estab.cep.length>0)">CEP: {{ estab.cep }}</span>
                                        <span class="tx_maisinfo" v-if="(estab.cidade!=null && estab.cidade.length>0) && (estab.cep==null || estab.cep.length==0)">{{ estab.cidade }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!--<div style="background-color: white; width: 1px; min-height: 25vmin; margin: 1.5vw;"/>-->

                        <div style="text-align: center; display: flex; justify-content: space-around; flex-direction: row; width: 100%; padding-right: 2vw; padding-left: 2vw; margin-top: 2vh;">
                            <a target="_blank" :href="'https://www.google.com/maps/search/?api=1&query=' + getAddressP1(estab)">
                                <div class="button_blue_c">
                                    <span style="position: relative; font-size: 1.9vh;">{{ getInterText(inter_ind.como_chegar) }}</span>
                                </div>
                            </a>
                            <a v-if="(estab.telefones!=null && estab.telefones.length>0)" :href="'tel:' + trimAll(estab.telefones)">
                                <div class="button_white_c">
                                    <img src="/static/imgs/ic_tel_b.png" class="im1_2"/>
                                    <span style="font-size: 1.9vh">{{ getInterText(inter_ind.ligar) }}</span>
                                </div>
                            </a>
                        </div>
                    </div>




                    <!-- ################    Comentarios    ################# -->
                    <br>
                    <div class="bodysubp3">
                        <h3>{{ getInterText(inter_ind.comentarios) }} ({{ commentaries.length }})</h3>

                        <div class="title2">
                            <div v-if="user.sucess" style="display: inline-block;">
                                <img v-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im1" style="vertical-align: top; margin-right: 10px;">
                                <img v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im1" style="vertical-align: top; margin-right: 10px;">
                            </div>
                            <img v-else src="/static/imgs/ic_profile2.png" alt="profile" class="im1" style="vertical-align: top;">

                            <textarea type="text" rows="3" class="search" :placeholder="getInterText(inter_ind.comentario_escreva) + '...'" v-model="commentTx"></textarea>
                        </div>
                        <div style="display: flex; justify-content: flex-end;">
                            <div style="background-color: var(--bg-purple); border-radius: 10px;" onMouseOver="this.style.cursor='pointer'" @click="addCommentary(0, -1)">
                                <span style="color: white; padding-right: 10px; padding-left: 10px;">{{ getInterText(inter_ind.enviar) }}</span>
                            </div>
                        </div>
                        <hr style="margin-left: 70px;">

                        <div v-for="(item, index) in commentaries" style="display: flex; flex-direction: column; width: 100%; position: relative;" :key="item.id">
                            <div style="display: flex; align-items: flex-start; margin-bottom: 2vw">
                                <div style="display: inline-block; text-align: start; width: 12%;">
                                    <img v-if='hasHttp(item.userPhoto)'  :src='unscapePath(item.userPhoto)' alt="profile" class="im1" :title="item.userName">
                                    <img v-else :src='baseUrlImg + "PROFILE/" + item.userPhoto'          alt="profile" class="im1" :title="item.userName">
                                </div>
                                <div style="display: flex; flex-direction: column; width: 74%; align-self: flex-start; font-size: 2vh;">
                                    <div style="display: inline-block; position: relative; vertical-align: top; text-align: justify;">
                                        <span style="color: darkblue">{{ getFirstAndLastWords(item.userName) }}</span>
                                        <span>{{ calcBehindTime(item.data) }}</span>
                                        <img v-if="user.sucess && item.idUsuario == user.id" src="/static/imgs/bt_erase.png" alt="profile" class="im_del_comment" @click="rmCommentary(item.id)">
                                    </div>
                                    <!--<div class="translate" style="display: inline-block; position:relative; vertical-align: top; text-align: justify;">-->
                                    <div v-if="renderCommentaries" style="display: inline-block; position:relative; vertical-align: top; text-align: justify;">
                                        <!--<div id="trans_area" class="translate_control" style="font-weight: bold; background-color: purple; display: none;">-->
                                        <!--</div>-->
                                        {{ item.tx_trans }}
                                    </div>
                                    <!--<div style="display: inline-block; position: relative; vertical-align: top; text-align: justify;">-->
                                    <div style="display: flex; flex-direction: column; position: relative; vertical-align: top; text-align: justify;">
                                        <span @click="setShowResponder(index)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.responder) }}</span>
                                        <div v-if="showRespComments != index" style="color: #acadaf; margin-top: 1vw; margin-bottom: 1vw;">
                                            <span v-if="item.resps != undefined && item.resps.length == 1" @click="setShowRespComments(index)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.ver) }} {{ item.resps.length }} {{ getInterText(inter_ind.resposta) }}</span>
                                            <span v-if="item.resps != undefined && item.resps.length > 1" @click="setShowRespComments(index)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.ver) }} {{ item.resps.length }} {{ getInterText(inter_ind.respostas) }}</span>
                                        </div>
                                        <div v-else style="color: #acadaf; margin-top: 1vw; margin-bottom: 1vw;">
                                            <span v-if="item.resps != undefined && item.resps.length == 1" @click="setShowRespComments(index)" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.resposta) }}: </span>
                                            <span v-if="item.resps != undefined && item.resps.length > 1" @click="setShowRespComments(index)" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.respostas) }}: </span>
                                        </div>

                                        <textarea v-if="showResponder==index" type="text" class="search" style="width: 100%;" :placeholder="getInterText(inter_ind.responda_comentario)" v-model="commentRespTx"></textarea>
                                    </div>
                                    <div v-if="showResponder==index" style="display: flex; justify-content: flex-end;">
                                        <div style="background-color: var(--bg-purple); border-radius: 10px;" onMouseOver="this.style.cursor='pointer'" @click="addCommentary(item.id, index)">
                                            <span style="color: white; padding-right: 10px; padding-left: 10px;">{{ getInterText(inter_ind.enviar_resposta) }}</span>
                                        </div>
                                    </div>






                                    <div v-if="showRespComments==index" v-for="(itemResp, indexResp) in item.resps" style="display: flex; flex-direction: column; width: 100%; position: relative;" :key="itemResp.id">
                                        <div style="display: flex; align-items: flex-start; margin-bottom: 2vw; position: relative; height: 100%;">
                                            <div style="display: inline-block; text-align: start; width: 12%; height: 100%;">
                                                <img v-if='hasHttp(itemResp.userPhoto)'  :src='unscapePath(itemResp.userPhoto)' alt="profile" class="im1" style="object-fit: cover; width: 8vw; height: 8vw;" :title="itemResp.userName">
                                                <img v-else :src='baseUrlImg + "PROFILE/" +itemResp.userPhoto'               alt="profile" class="im1" style="object-fit: cover; width: 8vw; height: 8vw;" :title="itemResp.userName">
                                            </div>
                                            <div style="display: flex; flex-direction: column; width: 74%; align-self: flex-start; margin-left: 1%;">
                                                <div style="display: inline-block; position: relative; vertical-align: top; text-align: justify;">
                                                    <span style="color: darkblue">{{ getFirstAndLastWords(itemResp.userName) }}</span>
                                                    <span>{{ calcBehindTime(itemResp.data) }}</span>
                                                    <img v-if="user.sucess && itemResp.idUsuario == user.id" src="/static/imgs/bt_erase.png" alt="profile" class="im_del_comment" @click="rmCommentary(itemResp.id)">
                                                </div>
                                                <div v-if="renderCommentaries" class="translate" style="display: inline-block; position:relative; vertical-align: top; text-align: justify;">
                                                    <!--<div id="trans_area" class="translate_control" style="font-weight: bold; background-color: purple; display: none;">-->
                                                    <!--</div>-->
                                                    {{ itemResp.tx_trans }}
                                                </div>
                                                <span @click="setShowResponder2(indexResp)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.responder) }}</span>
                                                <textarea v-if="showResponder2==indexResp" type="text" class="search" style="width: 100%;" :placeholder="getInterText(inter_ind.responda_comentario)" v-model="commentRespTx"></textarea>
                                                <div v-if="showResponder2==indexResp" style="display: flex; justify-content: flex-end;">
                                                    <div style="background-color: var(--bg-purple); border-radius: 10px;" onMouseOver="this.style.cursor='pointer'" @click="addCommentary(item.id, index)">
                                                        <span style="color: white; padding-right: 10px; padding-left: 10px;">{{ getInterText(inter_ind.enviar_resposta) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="div_joia2" style="width: 14%; align-self: flex-start; margin-top: 2vw;">
                                                <img v-if="isLiked(itemResp.id)" onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(itemResp, 0)" src="/static/imgs/ic_like_on.png" alt="joia up" class="im_joia1">
                                                <img v-else onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(itemResp, 1)"  src="/static/imgs/ic_like_off.png"  alt="joia up" class="im_joia1">
                                                <span style="margin-left: 5%;">{{ itemResp.qLikes }}</span>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div class="div_joia2" style="width: 14%; align-self: flex-start; margin-top: 4vw;">
                                    <img v-if="isLiked(item.id)" onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(item, 0)" src="/static/imgs/ic_like_on.png" alt="joia up" class="im_joia1">
                                    <img v-else onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(item, 1)"  src="/static/imgs/ic_like_off.png"  alt="joia up" class="im_joia1">
                                    <span style="margin-left: 5%;">{{ item.qLikes }}</span>
                                </div>
                            </div>
                            <!--<hr style="margin-top: 5px; width: 100%;">-->
                        </div>

                    </div>




                </div>
                <div v-if="estab==null" >
                    <br>
                    <span style="text-align: center"><h4>{{ getInterText(inter_ind.estabelecimento_nao) }}</h4></span>
                    <br><br><br>
                </div>

            </div>
        </div>

        <horizontal-msg/>

        <!--Barra de rodapé -->
        <div class="div_pat" >
                <span class="tx_parceiros">{{ getInterText(inter_ind.parceiros) }}</span><br>
                <a v-for="item in barra_pat" :href="item.url" target=”_blank”><img onerror="tryReloadImages(this)" :src="item.imgPath" class="im_pat"/></a>
        </div>
        <div v-if="estabs.length>0" class="tx_parceiros" style="display: flex; flex-direction: row; justify-content: center; padding-bottom: 0.5vh;">
            <span>&copy; {{ getYear() }} Advice Paraíba |</span>
            <a href="/mPolitica"><span>&nbsp;{{ getInterText(inter_ind.politica_privacidade) }}</span></a>
        </div>

        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_fechar_w.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>

                <!--<div class="div_face_w" style="margin-top: 10vh;" @click="externalLoginFace_checkLoginState()">-->
                    <!--<div class="div_faceim">-->
                        <!--<img src="/static/imgs/ic_face_blue.png" alt="facebook" class="im_face">-->
                    <!--</div>-->

                    <!--<div class="div_facetx">-->
                        <!--<span class="tx_face_m"> {{ getInterText(inter_ind.entre_face) }} </span>-->
                    <!--</div>-->
                <!--</div>-->


                <div v-if="!isiOS()" class="div_face_w" style="margin-top: 8vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">
                <!--<div class="div_face_w" style="margin-top: 1vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">-->
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>
                </div>
                <div v-else style="height: 12vh;"/>


                <div class="div_nome_l">
                    <!--<span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>-->
                    <!--<div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>-->
                    <span class="tx_nome_w" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" :class="editing[1].status ? 'input_name_w' : 'input_name_w_d'" type="text" v-model="editing[1].texto" tabindex="3" placeholder="E-mail" @click="clickInput(1, true)"/>
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <!--<span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>-->
                    <!--<div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>-->
                    <span class="tx_nome_w" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <div style="display: flex; flex-direction: row;">
                        <input id="nameid" :class="editing[0].status ? 'input_name_w' : 'input_name_w_d'" :type='editing[0].show ? "text" : "password"' v-model="editing[0].texto" :placeholder="getInterText(inter_ind.senha)" tabindex="4" v-on:keyup.enter="tryLogin()" @click="clickInput(0, true)"/>
                        <img v-if="editing[0].status" :src='editing[0].show ? "/static/imgs/ic_eye_open_w.png" : "/static/imgs/ic_eye_close_w.png"' style="width: 6vw; object-fit: contain;" @click="showPass(0)">
                    </div>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>
                </div>

                <div class="div_check" style="margin-top: 2vh;">
                    <span class="tx_check" style="cursor: pointer; margin-left: 0;">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>
                <div class="div_check" style="margin-top: 1vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1; text-align: left;">{{ getInterText(inter_ind.entrar_auto) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
                <div style="text-align: center;">
                    <span v-if="userNaoCadastrado" class="error_msg"> {{ getInterText(inter_ind.usuario_nao_cadastrado) }}</span>
                </div>
                <span v-for="item in msg_erros" class="error_msg" style="margin-left: 20px;"> * {{ item }} <br/> </span>

                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 10vh">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>
                    </div>
                    <!--<router-link to="mRegisterUser" >-->
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'mRegisterUser'}">
                        <div class="div_botao_login">
                            <span class="tx_continuar_w unselectable" > {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize2" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.058
                 0 0 0 0 0.384
                 0 0 0 0 0.674
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_blue" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.0625
                 0 0 0 0 0.375
                 0 0 0 0 0.672
                 0 0 0 1 0"/>
        </filter>

        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

        <div class="overlay" @click="changeSideBar()"></div>

        <!--Galeria de fotos overlay-->
        <div class="overgalery" >
            <div class="div_galery">
                <div class="div_fechar_over" @click="showGalery(false)" style="width: 100%;">
                    <img src="/static/imgs/bt_fechar_2.png" class="im_close_m_photo">
                </div>
                <Slider :banners="arrayRotate(estab.tbFotos, 0)" :baseUrlImg="baseUrlImg + '/MARCADOR/'" :fotoIndex="photoIndex" :showB="showingGalery" @emit-index="setPhotoIndex"/>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import { advMixin } from '../scripts/advMixin'
    import Slider from '@/components/templates/Slider.vue'

    export default {
        mixins: [advMixin],
        name: 'mEstabelecimento',
        data () {
            return {
                name: 'mEstabelecimento',
                estabs: [],
                estabs_full: [],
//                cats_full: [],
                cat: {},
                search_text: "",
                photoIndex: 0,
                showShare: false,
                showingSearch: false,
                actualWidth: 0,
                loading: {
                    cats: false,
                    estabs: false
                },
                response: {
                    status: "ok"
                },
                showingGalery: false,
                // tituloCat: "",
                // corCat: "",
                // corCat2: "#E4E4E4",
            }
        },
        components: {
            Slider: Slider
        },
        watch: {
            '$route.params': function (newQuestion, oldQuestion) {
                console.log('newQuestion ', newQuestion)
                console.log('oldQuestion ', oldQuestion)

                this.atualizaParametros();
            }
        },
        methods: {
            arrayRotate(arr2, count) {
                if (arr2 != undefined) {
                    let arr = arr2.slice();
                    count -= arr.length * Math.floor(count / arr.length);
                    arr.push.apply(arr, arr.splice(0, count));
                    return arr;
                }
            },
            share() {
                this.showShare = !this.showShare;
            },
            getInvestimento(estab) {
                if (estab.investimento > 5)
                    return 5;
                else
                    return estab.investimento;
            },
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            getEstabsSearch() {
                // console.log('getEstabsSearch: ', this.search_text);
                // console.log('vm.$refs.search_i.value: ', this.$refs.search_i.value);
                // console.log('getEstabsSearch:len: ', this.search_text.length);

                if (this.search_text.length < this.$refs.search_i.value.length) {
                    this.search_text = this.$refs.search_i.value;
                }

                if (this.search_text.length >= this.minSearchLen) {
                    this.$router.push({ name: 'mHome', query: { idCat: this.cat.id }, params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.cat.id, search: this.search_text} });
                }
            },
            showGalery(show) {
                // let el = document.getElementById("partLand")

                // se for mostrar a galeria deixa a tela Ajustar o viewport dinamicamente.
                if (show)
                    this.configureViewPort(show);

                if (show) {
                    $('.overgalery').fadeIn();
                    // remove o HorizontalMsg temporariamente enquanto estiver na galeria.
                    // if (el !== null) {
                    //     el.className = 'di_landscape_none'
                    // }
                } else {
                    $('.overgalery').fadeOut();
                    // if (el !== null) {
                    //     el.className = 'di_landscape'
                    // }
                }

                this.showingGalery = show;
            },
            nextPhoto(inc) {
                if (inc >= 0)
                    this.photoIndex = (this.photoIndex + inc) % this.estab.tbFotos.length;
                else {
                    if (this.photoIndex == 0)
                        this.photoIndex = this.estab.tbFotos.length - 1;
                    else
                        this.photoIndex = (this.photoIndex + inc);
                }
                console.log('nextPhoto::photoIndex: ', this.photoIndex)
            },
            getPhotoIndex(index) {
                return (this.photoIndex + index) % this.estab.tbFotos.length;
            },
            setPhotoIndex(index) {
                this.photoIndex = index
            },
            calcFontSize(nome) {
                // console.log('Entrei no calFontSize() ' + nome);
                var caracteres = nome.length;
                // console.log('Entrei no calFontSize() ' + caracteres);
                // console.log('Entrei no calFontSize()width ' + window.innerWidth);

                if (caracteres > 21) {
                    var fator = 1.1;
                    var calcWidth = this.actualWidth;
                    if (this.actualWidth==0)
                        calcWidth = window.innerWidth;
                    // console.log('Entrei no calFontSize()calcWidth ' + calcWidth);
                    var size = calcWidth*fator/caracteres;
                    var fs = 'font-size: ' + size + 'pt;';
                    // console.log('Entrei no calFontSize() ' + size);
                    // console.log('Entrei no calFontSize() ' + fs);
                    return fs;
                }
            },
            adjustCaracterEncoding() {
                var i;
                var vm = this;
                for (i=0 ; i<vm.estabs_full.length ; i++) {
                    try {
                        vm.estabs_full[i].nome = decodeURIComponent(escape(vm.estabs_full[i].nome));
                    } catch (e) {
                        vm.estabs_full[i].nome = unescape(vm.estabs_full[i].nome);
                    }
                    try {
                        vm.estabs_full[i].horario = decodeURIComponent(escape(vm.estabs_full[i].horario));
                    } catch (e) {
                        vm.estabs_full[i].horario = unescape(vm.estabs_full[i].horario);
                    }
                    if (vm.estabs_full[i].responsavel != null && vm.estabs_full[i].responsavel != undefined) {
                        try {
                            vm.estabs_full[i].responsavel = decodeURIComponent(escape(vm.estabs_full[i].responsavel));
                        } catch (e) {
                            vm.estabs_full[i].responsavel = unescape(vm.estabs_full[i].responsavel);
                        }
                    }
                    try {
                        vm.estabs_full[i].rua_num = decodeURIComponent(escape(vm.estabs_full[i].rua_num));
                    } catch (e) {
                        vm.estabs_full[i].rua_num = unescape(vm.estabs_full[i].rua_num);
                    }
                    try {
                        vm.estabs_full[i].bairro = decodeURIComponent(escape(vm.estabs_full[i].bairro));
                    } catch (e) {
                        vm.estabs_full[i].bairro = unescape(vm.estabs_full[i].bairro);
                    }
                    try {
                        vm.estabs_full[i].cidade = decodeURIComponent(escape(vm.estabs_full[i].cidade));
                    } catch (e) {
                        vm.estabs_full[i].cidade = unescape(vm.estabs_full[i].cidade);
                    }
                }
            },
            atualizaParametros() {
                console.log('atualizaParametros');
                console.log(this.$route.query);

                if (this.$route.query.id == null) {
                    console.log('id eh nulo');
                } else {
                    this.idEstab = this.$route.query.id;
                    console.log('id eh valido ' + this.idEstab);
                }

                console.log('Cidades:');
                this.getCities();
                console.log(this.city_full);

                this.getCommentaries(0, this.idEstab);

                this.atualizaEstab(this.idEstab);
            },
            atualizaEstab(idEstab) {
                console.log('atualizaEstab: ', idEstab);
                var vm = this;

                // Ta nesse for separado para que mesmo se nao tiver nenhum estabelecimento na categoria selecionada ele altere o tituloCat.
                var i;
                for (i=0 ; i<vm.estabs_full.length ; i++) {
                    var stab = vm.estabs_full[i];
                    if (stab.id == idEstab) {
                        vm.estab = stab;
                        vm.estab.descricao_trans = vm.estab.descricao2;
                        if (this.$router.currentRoute.params.estabSimple !== vm.estab.nomeSimple) {
                            history.replaceState('Test', vm.estab.nome, '/s/' + vm.estab.nomeSimple)
                        }
                        break;
                    }
                }

                var j = this.getEstabUserIndex(idEstab);
                if (j >= 0)
                    this.avaliacao = this.user.estabelecimentos[j].avaliacao;

                // descobre a categoria atual
                if (vm.estab!=null && vm.estab.tbCategoriaEstabelecimentos!=null) {
                    for (i = 0; i < vm.estab.tbCategoriaEstabelecimentos.length; i++) {
                        var cat = vm.estab.tbCategoriaEstabelecimentos[i];
                        // 53 eh o ID de Destaques.
                        // 67 eh o ID de Patrocinados
                        if (cat.id != 53 && cat.id != 67) {
                            vm.cat = cat;
                            // this.corCat = cat.cor;
                            // this.corCat2 = cat.cor2;
                            // this.tituloCat = cat.nome;
                            // vm.cat.id   = cat.id;
                            // vm.cat.nome = cat.nome;
                            // vm.cat.cor  = cat.cor;
                            // vm.cat.cor2 = cat.cor2;
                            // vm.cat.imgPath2 = cat.imgPath2;
                            break;
                        }
                    }
                }

                this.atualizaEstabs(vm.cat.id, false);
            },
            handleResize (event) {
                this.actualWidth = window.innerWidth;
                // console.log('window.innerWidth: ' + actualWidth);
            },
            trimAll(str){
                return str.replace(/\s/g,'');
            },
        },
        created() {
            console.log('created!!');

            this.loading.estabs = true

            if (this.$route.params.subCatIndex != null) {
                this.subCatIndex = this.$route.params.subCatIndex;
                console.log('setando o subCatIndex para: ', this.subCatIndex);
            }
            else
                console.log('subCatIndex nao veio');

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.idCat != null) {
                    this.idCat = this.$route.params.idCat;
                    this.cat.id = this.$route.params.idCat;
                }
                this.atualizaParametros();
                this.loading.estabs = false
            }
            else {
                console.log('this.$route.params.estabSimple: ', this.$route.params.estabSimple);
                console.log('Baixando estabs!!');
                if (this.$route.params.estabSimple != null) {
                    this.getEstabsCatsHome(this.$route.params.estabSimple);
                } else {
                    this.getEstabsCatsHome();
                }
            }

            if (this.$route.params.anuncios) {
                console.log('Usando anuncios passados por parametro!!');
                this.anuncios = this.$route.params.anuncios;
            }
            else {
                console.log('Baixando estabs!!');
                this.getAnuncios();
            }

            if (this.$route.query.id != null)
                this.idEstab = this.$route.query.id;

            // if (this.$route.params.user) {
            //     this.user = this.$route.params.user;
            // }

            window.addEventListener('resize', this.handleResize);

            console.log('Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted, idioma: ' + this.user.idioma);

            this.barra_pat = this.shuffle(this.barra_pat);

            if (this.user.idioma > 0) {
                this.changeIdioma(this.user.idioma);
            }

            console.log('Terminei o mounted!!');
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.handleResize);
        }
    }
</script>

<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/adv.css" scoped/>
<style src="../assets/css/advGeral.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome {
        background-color: var(--main-bg-color-new);
        /*background-color: #E4E4E4;*/
    }
    .wrapper {
        background-color: var(--main-bg-color-new);
    }
    html, body {
        background-color: var(--main-bg-color-new);
    }

    .title0 {
        /*background-color: red;*/
        text-align: left;
    }

    .head1, .head2, .head3 {
        height: 100%;
        margin:auto;
        display: inline-block;
        position: relative;
    }
    .head1 {
        width: 13%;
        /*background-color: red;*/
        display: flex;
        justify-content: center;
    }
    .head2 {
        /*width: 56%;*/
        width: 65%;
        /*background-color: green;*/
        text-align: center;
    }
    .head3 {
        /*width: 29%;*/
        width: 20%;
        /*background-color: aqua;*/
        text-align: right;
    }
    .im_categoria3 {
        background-size: contain;
        object-fit: contain;
        filter: url(#colorize);
        width: 30px;
        height: 30px;
        margin-right: 2vw;
        margin-left: 2vw;
        width: 3vh;
        height: 3vh;
    }
    .im_pontos {
        /*background-color: red;*/
        margin-right: 2vw;
    }
    #dismiss {
        top: 0;
        left: 0;
        margin-left: 5px;
        margin-top: 10px;
    }
    .di_profile, .di_profile_m {
        display: inline-block;
        /*background-color: red;*/
        position: relative;
        height: 100%;
        cursor: pointer;
    }

    .di_profile_m {
        padding-top: 7%;
        padding-bottom: 7%;
        margin-right: 5%;
    }

    .im_profile, .im_profile_2 {
        display: flex;
        height: 80%;
        margin-top: 0.74vh;
    }
    .im_profile_2 {
        margin-top: 10px;
        height: 40px;
        width: 40px;
        object-fit: cover;
        border-radius: 50%;
    }
    .im_degrade {
        position: absolute;
        width: 100%;
        height: 12px;
    }

    .di_estabelecimento0 {
        background-color: white;
        margin-top: 5px;
        width: 96vw;
        padding: 2vw;
        margin-right: 2vw;
        margin-left: 2vw;
        alignment: center;
        text-align: center;
    }
    .di_estabelecimento1 {
        /*background-color: blue;*/
        width: 100%;
        text-align: center;
        display: inline-block;
    }
    .di_estabelecimento2 {
        margin-top: 5px;
        text-align: left;
    }
    .di_estabelecimento3 {
        width: 100%;
        display: flex;
        /*background-color: pink;*/
        /*justify-content: space-between;*/
    }
    .di_texto {
        /*background-color: red;*/
        padding-right: 2vw;
        padding-left: 2vw;
        /*max-height: 80vw;*/
        /*overflow-y: scroll;*/
    }
    .imgDestaques {
        /*object-fit: cover;*/
        object-fit: cover;
        width: 100%;
        height: 100%;
        max-height: 45vh;
        min-height: 30vh;
        background-color: var(--empty-color);
    }
    .imgDestaques-empty {
        max-height: 30vh;
        height: 30vh;
    }
    .txt {
        /*font-size: 12pt;*/
        font-size: 2.5vh;
        text-align: left;
        display:block;
    }
    .di_im_small {
        /*background-color: red;*/
        margin-top: 5px;
        position: relative;
    }
    .di_small_p1 {
        /*background-color: var(--empty-color);*/
        /*background-color: green;*/
        position: relative;
        display: inline-block;
        width: 50%;
        text-align: left;
    }
    .di_small_p2 {
        /*background-color: var(--empty-color);*/
        /*background-color: blue;*/
        position: relative;
        display: inline-block;
        width: 50%;
        text-align: right;
    }
    .im_small {
        /*background-color: green;*/
        position: relative;
        object-fit: cover;
        /*width: 44.5vw;*/
        width: 98.5%;
        height: 30vw;
        min-height: 20vw;
        background-color: var(--empty-color);
    }
    .im_cat_min {
        width: 17px;
        height: 17px;
        margin-right: 10px;
        object-fit: contain;
    }
    .tx_categoria {
        /*background-color: yellow;*/
        display: inline-grid;
        white-space: pre-line;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--bg-blue);
        /*line-height: 0.9;*/
    }
    .scrollhorizontal {
        /*padding-top: 85px;*/
        margin-top: var(--top-bar-heigth);
        padding-top: 1vh;
        overflow-x: auto;
        white-space: nowrap;
        display: flex;
    }
    .scrollhorizontal::-webkit-scrollbar {
        /* This is the magic bit */
        display: none;
    }

    .search1 {
        /*background-image: url('/static/imgs/bg_search01m2.png');*/
        /*background-color: #b6b6b6;*/
        /*background-repeat: no-repeat;*/
        /*background-size: 100% 30px;*/
        /*background-color: green;*/
        border: none;
        outline:none;
        color: var(--menu-icon-gray);
        /*color: red;*/
        position: center;
        padding-left: 2%;
        width: 93%;
        height: 100%;
        /*font-size: 10pt;*/
        font-size: 2.5vh;
        text-align: left;
    }
    .search_lupa {
        width: 6%;
        height: 50%;
        object-fit: scale-down;
        /*background-color: red;*/
        /*margin-left: 2.5%;*/
        position: relative;
    }
    .bodysubp21 {
        /*background-color: var(--ligth-gray);*/
        background-size: 100% 100%;
        /*background-color: green;*/
        display: flex;
        align-items: center;
        padding: 2vw;
        text-align: left;
        flex-direction: column;
        color: var(--font-dark-gray);
    }
    .bodysubp3 {
        /*background-color: green;*/
        color: var(--font-dark-gray);
        text-align: left;
    }
    .traje {
        display: inline-block;
        width: 60px;
        vertical-align: middle;
        text-align: center;
        margin-left: 3px;
        margin-right: 3px;
    }
    .im1 {
        display: inline-block;
        width: 10vw;
        height: 10vw;
        margin-right: 1vw;
        vertical-align: middle;
        text-align: center;
        border-radius: 50%;
        background-size: contain;
        object-fit: cover;
    }
    .im_traje {
        /*background-color: red;*/
        display: inline-block;
        width: 4.5vh;
        vertical-align: middle;
        text-align: center;
    }
    .title {
        display: flex;
        align-items: center;
        justify-content: left;
        background-color: white;
        border-radius:5px;
        margin-right: 2vw;
        margin-left: 2vw;
        margin-bottom: 1vw;
        padding: 2px;
        /*font-size: 20pt;*/
        font-size: 4vh;
        height: 5vh;
        /*color: red;*/
        color: var(--bg-blue);
        /*background-color: red;*/
    }
    .title2 {
        vertical-align: text-top;
    }

    .div_joia, .div_joia2 {
        /*background-color: #0c5460;*/
        text-align: right;
        width: 80px;
        position: absolute;
        bottom: 10px;
        right: 0px;
        align-items: center;
    }
    .div_joia2 {
        position: relative;
        bottom: 0px;
        display: flex;

        /*align-self: flex-end;*/
        /*justify-self: flex-end;*/
        justify-content: center;
    }
    .div_arrow_l, .div_arrow_r, .div_fechar_over {
        /*background-color: green;*/
        position: absolute;
        top:0;
        height: 100%;
        min-width: 40px;
        vertical-align: center;
    }
    .div_arrow_r, .div_fechar_over{
        right: 1vw;
    }
    .div_arrow_l {
        left: 1vw;
    }
    .div_fechar_over {
        position: absolute;
        top: 1vw;
        padding-right: 3vw;
        display: flex;
        justify-content: flex-end; /*right, left*/
        align-items: flex-start;
        /*background-color: blue;*/
    }
    .im_arrow {
        position: absolute;
        vertical-align: middle;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -o-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;
        cursor: pointer;
    }
    .im_arrow:hover {
        -webkit-filter: brightness(90%);
        filter: brightness(90%);
    }

    .overgalery {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: rgba(10, 10, 10, 0.95);
        /*background-color: purple;*/
        /*z-index: 1;*/
        z-index: 1000;
        display: none;
        vertical-align: middle;
        top: 0;
    }
    .div_galery {
        /*vertical-align: middle;*/
        /*display: inline-block;*/
        /*background-color: red;*/
        display: flex;
        position: relative;
        flex-direction: column;
        /*align-items: center;*/
        justify-content: center;
        /*align-content: center;*/
        /*z-index: 1;*/
        /*width: 100%;*/
        height: 100%;
        /*padding-right: 2.5vw;*/
        /*padding-left: 2.5vw;*/
        /*margin: 0;*/
        /*padding: 0;*/
    }
    .imgGalery {
        /*background-color: black;*/
        /*max-height: 100vh;*/
        /*padding-bottom: 5vh;*/
        /*max-height: 85vh;*/
        /*object-fit: cover;*/
        object-fit: contain;
        /*margin-top: 0vh;*/
        /*height: 100vw;*/
        margin-bottom: -4vh;
        width: 100vw;
        height: 100vh;
    }

    /* Portrait */
    @media screen and (orientation:portrait) {
        .imgGalery {
            /*margin-top: -5vh;*/
            /*width: 100vw;*/
        }
    }
    /* Landscape */
    @media screen and (orientation:landscape) {
        .imgGalery {
            /*width: 85vw;*/
        }
        .div_fechar_over {
            position: absolute;
        }
    }

    .tx_parceiros {;
        font-size: 2.2vh;
        /*color: #040505;*/
        color: #858585;
        /*background-color: red;*/
    }

    .tx_address {
        font-size: 2.4vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/mEstabelecimento.vue